import { Component, OnDestroy, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { format } from 'date-fns';

import * as authSelectors from '@auth/store/auth.selectors';
import { DataService } from '@data/data.service';

@Component({
  selector: 'app-modal-dialog',
  templateUrl: './modal-dialog.component.html',
  styleUrls: ['./modal-dialog.component.scss'],
})
export class ModalDialogComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();

  display: boolean;
  header: string;
  content: string;
  message: any;
  type: string;
  serverError: boolean;
  timestamp: string;

  authState$: any;

  constructor(private store: Store, public dataService: DataService) {}

  ngOnInit(): void {
    this.authState$ = this.store.select(authSelectors.selectAuthData);

    this.dataService.globalModalDialogDisplay$.pipe(takeUntil(this.destroy$)).subscribe((display) => {
      this.display = display;
    });

    this.dataService.globalModalDialogHeader$.pipe(takeUntil(this.destroy$)).subscribe((header) => {
      this.header = header;
    });

    this.dataService.globalModalDialogMessage$.pipe(takeUntil(this.destroy$)).subscribe((message) => {
      if (!message) {
        return;
      }

      this.timestamp = format(new Date(), 'yyyy-MM-dd HH:mm:ss');

      if (typeof message === 'string') {
        this.type = 'string';
        this.content = message;
      } else {
        this.type = 'error';
        this.message = message;
      }

      if (this.type === 'error' && this.message.type === 'server') {
        this.serverError = true;
      } else {
        this.serverError = false;
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  closeModal = () => {
    this.dataService.globalModalDialogDisplay$.next(false);
    this.dataService.globalModalDialogHeader$.next(null);
    this.dataService.globalModalDialogMessage$.next(null);
  };
}
